import { CollaboratorQueryKeys } from "@shared/libs/react-query/query-keys.constants";
import {
  infiniteCursoredQueryGenerator,
  mutationGenerator,
  queryGenerator,
  suspenseQueryGenerator,
} from "@shared/libs/react-query/query.hooks";

import {
  deleteVocal,
  getAllCollaborators,
  getAllCollaboratorVocals,
  getCollaboratorCalendarEvents,
  getCollaboratorChatSettings,
  getCollaboratorNotifications,
  getCollaboratorsAgencies,
  getCollaboratorsLeaves,
  getContractorCollaboratorsAgencies,
  getMe,
  getOneCollaborator,
  getOneCollaboratorByDsitUuid,
  getOneCollaboratorTask,
  getTasks,
  postCollaboratorNotificationRead,
  postCollaboratorNotificationsReadAll,
  postVocal,
  putCollaboratorTask,
  updateCollaboratorChatSettings,
  updateVocal,
} from "..";

export const useGetAllCollaborators = queryGenerator(
  CollaboratorQueryKeys.COLLABORATORS,
  getAllCollaborators
);

export const useGetAllCollaboratorVocals = queryGenerator(
  CollaboratorQueryKeys.COLLABORATOR_VOCALS,
  getAllCollaboratorVocals
);

export const usePostVocal = mutationGenerator(postVocal);

export const useDeleteVocal = mutationGenerator(deleteVocal);

export const useUpdateVocal = mutationGenerator(updateVocal);

export const useGetCollaboratorsAgencies = queryGenerator(
  CollaboratorQueryKeys.COLLABORATOR_AGENCY,
  getCollaboratorsAgencies
);

export const useGetContractorCollaboratorsAgencies = queryGenerator(
  CollaboratorQueryKeys.CONTRACTOR_COLLABORATOR_AGENCY,
  getContractorCollaboratorsAgencies
);

export const useGetOneCollaborator = queryGenerator(
  CollaboratorQueryKeys.COLLABORATOR,
  getOneCollaborator
);

export const useGetOneCollaboratorByDsitUuid = queryGenerator(
  CollaboratorQueryKeys.COLLABORATOR_BY_DSIT_UUID,
  getOneCollaboratorByDsitUuid
);

export const useGetMe = suspenseQueryGenerator(CollaboratorQueryKeys.ME, getMe);

export const useGetOneCollaboratorTask = queryGenerator(
  CollaboratorQueryKeys.COLLABORATOR_TASK,
  getOneCollaboratorTask
);

export const useGetCollaboratorChatSettings = queryGenerator(
  CollaboratorQueryKeys.COLLABORATOR_CHAT_SETTINGS,
  getCollaboratorChatSettings
);

export const useUpdateCollaboratorChatSettings = mutationGenerator(updateCollaboratorChatSettings);

export const usePutCollaboratorTask = mutationGenerator(putCollaboratorTask);

export const useGetCollaboratorNotifications = infiniteCursoredQueryGenerator(
  CollaboratorQueryKeys.COLLABORATOR_NOTIFICATIONS,
  getCollaboratorNotifications
);

export const usePostCollaboratorNotificationsReadAll = mutationGenerator(
  postCollaboratorNotificationsReadAll
);

export const usePostCollaboratorNotificationRead = mutationGenerator(
  postCollaboratorNotificationRead
);

export const useGetCollaboratorsLeaves = queryGenerator(
  CollaboratorQueryKeys.COLLABORATOR_LEAVES,
  getCollaboratorsLeaves
);

export const useGetTasks = queryGenerator(CollaboratorQueryKeys.COLLABORATOR_TASKS, getTasks);
export const useGetCollaboratorCalendarEvents = queryGenerator(
  CollaboratorQueryKeys.COLLABORATOR_CALENDAR_EVENTS,
  getCollaboratorCalendarEvents
);
